import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';
import { KeypadSchema } from '@/components/Betslip/components/Keyboard/styles/Keypad.styles';

export const keypadStyles: KeypadSchema = {
  buttonActionProps: {
    variant: 'outline',
    fontFamily: 'body',
    borderColor: '#FBC915',
    border: '2px solid',
    color: 'white',
    height: '5',
    borderRadius: '3px',
    bg: 'transparent',
    boxShadow: 'none',
  },
};
export const FlexKeypadWrapper: CSSObject = {
  p: '0.5',
  width: ['100%', null, '102%', '100%'],
  left: [null, null, '0'],
  bg: 'alpha.700',
  borderTop: '2px solid',
  borderTopColor: '#FFC31C',
};
export const buttonKeysProps: CustomButtonProps = {
  variant: 'secondary',
  fontWeight: '400',
  pt: '0.5',
  fontSize: 'lg',
  height: '100%',
  color: '#2B045C',
  sx: {
    svg: {
      pos: 'relative',
      bottom: '2px',
    },
  },
};
export const buttonDoneKeyProps: CustomButtonProps = {
  variant: 'primary',
  fontWeight: 'bold',
  pt: '0.5',
  fontSize: 'lg',
  height: '100%',
};
export const buttonBatchKeysProps: CustomButtonProps = {
  variant: 'primary',
  fontWeight: '400',
  pt: '0.5',
  fontSize: 'lg',
  height: '100%',
  color: '#FFC31C',
  textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
};
